import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-clip",
  "use": "spr-clip-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" id=\"spr-clip\">\r\n<path d=\"M3,16c-0.8,0-1.6-0.3-2.1-0.9c-1.2-1.2-1.2-3.2,0-4.4l9.3-9.5C11,0.4,12,0,13,0c1.1,0,2.1,0.4,2.8,1.2C16.6,2,17,3,17,4.1\r\n\tc0,1.1-0.4,2.1-1.2,2.9l-7.3,7.5c-0.2,0.2-0.6,0.2-0.8,0c-0.2-0.2-0.2-0.6,0-0.8L15,6.1c0.5-0.6,0.8-1.3,0.8-2.1\r\n\tc0-0.8-0.3-1.5-0.8-2.1c-0.5-0.6-1.3-0.9-2-0.9c-0.8,0-1.5,0.3-2,0.9l-9.3,9.5c-0.7,0.8-0.7,2,0,2.7c0.7,0.7,2,0.7,2.7,0l6.3-6.4\r\n\tc0.2-0.2,0.3-0.4,0.3-0.7c0-0.2-0.1-0.5-0.3-0.7c-0.4-0.4-0.9-0.4-1.3,0L5,10.9c-0.2,0.2-0.6,0.2-0.8,0c-0.2-0.2-0.2-0.6,0-0.8\r\n\tl4.3-4.4c0.8-0.8,2.1-0.8,2.9,0C11.8,6.1,12,6.7,12,7.2c0,0.5-0.2,1.1-0.6,1.5l-6.3,6.4C4.6,15.7,3.8,16,3,16z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ../img/sprite/clip.svg
// module id = 308
// module chunks = 0